export default __webpack_public_path__ + "static/media/b4.3bb3a4d4.svg";